import React from 'react';

interface GhostProps {
  width: number | `${number}%`;
  height: number | `${number}%`;
  title: string;
  titleSize?: number;
}

export const Ghost: React.FC<GhostProps> = ({ width, height, title, titleSize = 12 }) => {
  return (
    <div
      style={{
        width,
        height,
        backgroundColor: '#F8F9FC',
        border: '1px dashed var(--vkit-color-default)',
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: titleSize,
      }}>
      {title}
    </div>
  );
};
